
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "sorttime"
})

export class SortPipe {
  transform(array: any) {

    const AddDateArray = array.map(obj => {
      return {...obj, start: obj.start.replace(obj.start, "Jan 28 2022 " + obj.start).trim() };
    });

    AddDateArray.sort((a, b) => {
      var start = new Date(a.start).getTime();
      var end =  new Date(b.start).getTime();
      return start > end ? 1 : -1;
    });

    AddDateArray.forEach(function(element, index, theArray) {
      let removeSecond = new Date(`${element.start}`).toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' });
      removeSecond = removeSecond.replace(/^0+/, '');
      theArray[index].start = removeSecond;
    });

    // const resultArray = AddDateArray.map(obj => {
    //   return { ...obj, start: obj.start.replace("Jan 28 2022", "").trim() };
    // });
    return AddDateArray;
  }
}